import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { envApiUrl } from './envApiUrl';

export type Measurement = {
  id: number;
  value: number;
  comment: string;
  createdAt: string;
  updatedAt: string;
  mydayId: number;
  healthmetrictypeId: number;
  userId: number;
  myday: {
    id: number;
    date: string;
  };
};

export type HealthMetricType = {
  id: number;
  name: string;
  unit: string;
  description?: string;
  description_en?: string;
  unit_alternative?: string;
  conversion_rate?: number;
  comment?: string;
  ref_lower?: number;
  ref_upper?: number;
  measurements?: Measurement[];
  createdAt: string; // ISO date string
  updatedAt: string; // ISO date string
};

export const useHealthmetrictypesWithMeasurements = () => {
  return useQuery({
    queryKey: ['useHealthmetrictypesWithMeasurements'],

    queryFn: () =>
      axios
        .get(`${envApiUrl}/healthmetrictypes/withMeasurements`, {
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'x-csrf-token',
        })
        .then((response) => {
          return response.data as HealthMetricType[];
        })
        .catch((error) => {
          if (error.response) {
            console.log('useHealthmetrictypesWithMeasurements Error : ', error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          }
          if (error.response?.status === 403) {
            window.location.href = '/';
          }
        }),
    staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
    gcTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
    refetchOnWindowFocus: false, // Don't refetch on window focus
    refetchOnMount: false, // Don't refetch on mount if data exists
  });
};
